export default "__VITE_ASSET__CQBDSik5__"